export default "__VITE_ASSET__ffa69eb2__"